<!-- Special promotion tab — Net X2/X3 pricingLogicAlgorithm editor. Uses the
     same enr-section-card + enr-collapsible chrome as every other edit tab
     (Overview / Pricing / Term / Shelf) so this reads as a sibling card
     instead of a bespoke one. -->

<div class="enr-section-card enr-section-card--readonly">
  <enr-collapsible
    title="Special promotion — Net X2/X3"
    [expanded]="true"
    ariaLabel="Special promotion — Net X2/X3"
  >
    <span slot="title" class="flex items-center gap-2">
      <span class="sp-title-num" aria-hidden="true">1</span>
      <span class="enr-section-card__title">Special promotion — Net X2/X3</span>
    </span>

    <div class="sp-card-body">
      @if (selectedPrice(); as price) {
      <form [formGroup]="form" class="flex flex-col gap-4">
        <!-- POP ID + search -->
        <div class="sp-popid-row">
          <enr-input
            label="POP ID (Net X2/X3 package)"
            placeholder="e.g. 1DtzYZHdx77"
            formControlName="popId"
          ></enr-input>
          <enr-button
            variant="primary"
            [leadingIcon]="true"
            [loading]="lookupState() === 'loading'"
            [disabled]="lookupState() === 'loading'"
            (clicked)="onSearch()"
            [size]="'medium'"
          >
            <mat-icon slot="leading-icon">search</mat-icon>
            Search
          </enr-button>
        </div>

        <!-- Everything below the search is revealed only once a POP ID
             resolves to a package (lookupState === "ok"). -->
        @if (lookupState() === "ok") {
        <!-- Resolved package — read-only summary. -->
        <div class="sp-resolved">
          <div class="sp-resolved__badge">
            <mat-icon class="sp-resolved__check" aria-hidden="true"
              >check_circle</mat-icon
            >
            <span class="sp-resolved__label">Package resolved</span>
            <span class="sp-resolved__ro">Read-only</span>
          </div>
          @if (packageNameRows().length > 0) {
          <dl class="sp-resolved__names">
            @for (row of packageNameRows(); track row.locale) {
            <div class="sp-resolved__name-row">
              <dt class="sp-resolved__lang">{{ row.label }}</dt>
              <dd
                class="sp-resolved__value"
                [class.sp-resolved__value--empty]="!row.value"
              >
                {{ row.value || "—" }}
              </dd>
            </div>
            }
          </dl>
          } @else {
          <div class="sp-resolved__single">{{ packageName() }}</div>
          }
        </div>

        <!-- Package type -->
        <enr-select
          label="Package type"
          [options]="packageTypeOptions"
          formControlName="packageType"
        ></enr-select>

        <!-- Periods -->
        <div class="sp-section-head">
          <span class="sp-section-title">
            Period
            <span class="sp-count">{{ periods.length }}/{{ maxPeriods }}</span>
          </span>
          <enr-button
            variant="outline"
            [disabled]="periods.length >= maxPeriods"
            (clicked)="addRow()"
          >
            + Create New Date
          </enr-button>
        </div>

        <div formArrayName="periods" class="flex flex-col gap-3">
          @for (group of periods.controls; track $index) {
          <div class="sp-period-row" [formGroupName]="$index">
            <enr-input
              type="date"
              label="Start date"
              valueFormat="string"
              formControlName="startDate"
              [minDate]="startMinFor($index)"
            ></enr-input>
            <enr-input
              type="date"
              label="End date"
              valueFormat="string"
              formControlName="endDate"
              [minDate]="endMinFor($index)"
            ></enr-input>
            @if (statusFor($index); as st) {
            <enr-status
              class="sp-status-badge"
              [status]="statusType($index)"
              [customText]="st"
            />
            } @else {
            <span class="sp-status">—</span>
            }
            <enr-button-icon
              ariaLabel="Delete period"
              (clicked)="removeRow($index)"
            >
              <mat-icon>delete_outline</mat-icon>
            </enr-button-icon>
          </div>
          } @empty {
          <p class="sp-empty">
            No promotion periods configured. "Create New Date" to add one.
          </p>
          }
        </div>

        <!-- Validation -->
        @if (errors().length > 0) {
        <div class="sp-errors" role="alert">
          @for (err of errors(); track err) {
          <div class="sp-errors__item">{{ err }}</div>
          }
          <div class="sp-hint">
            Fix these to include the changes in the next Save.
          </div>
        </div>
        } } @else if (lookupState() === "notfound") {
        <output class="sp-lookup-msg sp-lookup-msg--notfound">
          <mat-icon class="sp-lookup-msg__icon" aria-hidden="true"
            >search_off</mat-icon
          >
          <div class="sp-lookup-msg__body">
            <div class="sp-lookup-msg__title">Package not found</div>
            <div class="sp-lookup-msg__text">
              No package matched that POP ID. Check it and search again.
            </div>
          </div>
        </output>
        } @else {
        <output class="sp-lookup-msg">
          <mat-icon class="sp-lookup-msg__icon" aria-hidden="true"
            >travel_explore</mat-icon
          >
          <div class="sp-lookup-msg__body">
            <div class="sp-lookup-msg__title">Search a POP ID to begin</div>
            <div class="sp-lookup-msg__text">
              Enter the Net X2/X3 POP ID above and Search to load the package,
              then configure its promotion periods.
            </div>
          </div>
        </output>
        }
      </form>
      } @else {
      <p class="sp-empty">This package has no prices to configure.</p>
      }
    </div>
  </enr-collapsible>
</div>
